import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import { setupOktaAuthenticated } from '@/lib/auth/checkOktaAuthenticated';

const _ = { setupOktaAuthenticated };

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: to => {
      return { path: '/login' }
    },
  },
  {
    path: '/signup-email',
    name: 'signupEmail',
    alias: '/login/profile/email',
    component: () => import(/* webpackChunkName: "VerifyEmail" */ '../views/signup/EmailVerificationView'),
  },
  {
    path: '/login/email/:type?',
    name: 'emailToken',
    component: () => import(/* webpackChunkName: "NewPassword" */ '../views/login/EmailTokenView'),
  },
  {
    path: '/login/callback',
    name: 'callback',
    component: () => import(/* webpackChunkName: "Success" */ '../views/CallbackView'),
  },
  {
    path: '/login/error',
    name: 'loginError',
    component: () => import(/* webpackChunkName: "Login" */ '../views/LoginView'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/LoginView'),
  },
  {
    path: '/dashboard/set-password',
    name: 'SetPassword',
    component: () => import(/* webpackChunkName: "ClientList" */ '../views/dashboard/ResetPassword'),
    meta: { requiresAuth: true },
  },
  // {
  //   path: '/dashboard/advisor/payment-info',
  //   name: 'AdvisorPaymentInfo',
  //   component: () => import(/* webpackChunkName: "ClientList" */ '../views/dashboard/advisors/AdvisorPaymentInfo'),
  //   meta: { requiresAuth: true },
  // },
  {
    path: '/dashboard/clients',
    name: 'ClientList',
    component: () => import(/* webpackChunkName: "ClientList" */ '../views/dashboard/clients/ClientsView'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard/clients/:id',
    name: 'ClientListId',
    component: () => import(/* webpackChunkName: "ClientList" */ '../views/dashboard/clients/ClientView'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '/dashboard/clients/:id/summary',
        name: 'ClientSummary',
        component: () => import(/* webpackChunkName: "ClientListSummary" */ '../components/dashboard/advisor/clients/ClientSummary'),
        meta: { requiresAuth: true },
      },
      {
        path: '/dashboard/clients/:id/accounts/',
        name: 'ClientAccounts',
        component: () => import(/* webpackChunkName: "ClientListSummary" */ '../components/dashboard/advisor/clients/ClientAccounts'),
        meta: { requiresAuth: true },
      },
      {
        path: '/dashboard/clients/:id/accounts/:accountId',
        name: 'ClientAccountDetails',
        component: () => import(/* webpackChunkName: "ClientListSummary" */ '../components/dashboard/advisor/clients/ClientAccountDetails'),
        meta: { requiresAuth: true },
      },
      {
        path: '/dashboard/clients/:id/reports/:tab?',
        name: 'ClientReports',
        component: () => import(/* webpackChunkName: "ClientListSummary" */ '../components/dashboard/advisor/clients/ClientReports'),
        meta: { requiresAuth: true },
      },
      {
        path: '/dashboard/clients/:id/fees',
        name: 'ClientFees',
        component: () => import(/* webpackChunkName: "ClientListSummary" */ '../components/dashboard/advisor/clients/ClientFees'),
        meta: { requiresAuth: true },
      },
      {
        path: '/dashboard/clients/:id/documents/:tab?',
        name: 'ClientDocuments',
        component: () => import(/* webpackChunkName: "ClientListSummary" */ '../components/dashboard/advisor/clients/ClientDocuments'),
        meta: { requiresAuth: true },
      },
      {
        path: '/dashboard/clients/:id/deposits-withdrawals',
        name: 'ClientDepositsWithdrawals',
        component: () => import(/* webpackChunkName: "ClientListSummary" */ '../components/dashboard/advisor/clients/ClientDepositsWithdrawals'),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/dashboard/sponsors',
    name: 'SponsorsList',
    component: () => import(/* webpackChunkName: "SponsorsList" */ '../views/dashboard/sponsors/SponsorsView'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard/sponsors/add',
    name: 'SponsorAdd',
    component: () => import(/* webpackChunkName: "SponsorsList" */ '../views/dashboard/sponsors/add/SponsorAdd'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard/sponsors/:id/edit',
    name: 'SponsorEdit',
    component: () => import(/* webpackChunkName: "SponsorsList" */ '../views/dashboard/sponsors/edit/PlanSponsorEditView'),
    meta: { requiresAuth: true },
  },

  {
    path: '/dashboard/sponsors/:id/admin/add',
    name: 'SponsorAddAdmin',
    component: () => import(/* webpackChunkName: "SponsorsList" */ '../views/dashboard/sponsors/admin/PlanSponsorAddAdminView'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard/sponsors/:id/plan/add',
    name: 'AddPlanSponsor',
    component: () => import(/* webpackChunkName: "SponsorsList" */ '../views/dashboard/sponsors/plans/add/SponsorAddPlanBase'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard/sponsors/:id/plan/:planId/details',
    name: 'ViewSponsorPlanDetails',
    component: () => import(/* webpackChunkName: "SponsorsList" */ '../views/dashboard/sponsors/plans/details/SponsorPlanDetailsView'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard/sponsors/:id/plan/:planId/employees',
    name: 'ViewSponsorPlanEmployees',
    component: () => import(/* webpackChunkName: "SponsorsList" */ '../views/dashboard/sponsors/plans/members/SponsorPlanMembersList'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard/sponsors/details/:id?',
    name: 'PlanSponsorDetails',
    component: () => import(/* webpackChunkName: "SponsorsList" */ '../views/dashboard/sponsors/details/SponsorDetailsView'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard/settings/:page?',
    name: 'settings',
    component: () => import(/* webpackChunkName: "Settings" */ '../views/dashboard/settings/SettingsPageView'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard/settings/basic/email',
    name: 'settingsBasicEmail',
    component: () => import(/* webpackChunkName: "SettingsBasicEmail" */ '../views/dashboard/settings/SettingsEmailVerificationView'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard/settings/verification/:mfa',
    name: 'settingsVerificationMfa',
    component: () => import(/* webpackChunkName: "SettingsVerificationMfa" */ '../views/dashboard/settings/verification/MfaSetupView'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "Dashboard" */ '../views/dashboard/DashboardView'),
    meta: { requiresAuth: true },
  },
  {
    path: '/signout',
    name: 'signout',
    component: () => import(/* webpackChunkName: "Signout" */ '../views/SignoutView'),
    meta: { requiresAuth: true },
  },
  {
    path: '/*',
    redirect: to => {
      return { path: '/login' }
    },
  },
];

const demoRoute = {
  path: '/demo',
  name: 'DemoExamples',
  component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/index'),
  children: [
    {
      path: '/demo/valet/',
      name: 'ValetExamples',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet'),
    },
    {
      path: '/demo/valet/AvatarExample',
      name: 'AvatarExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/AvatarExample'),
    },
    {
      path: '/demo/valet/AccordianExample',
      name: 'AccordianExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/AccordianExample'),
    },
    {
      path: '/demo/valet/ConfirmDialogExample',
      name: 'ConfirmDialogExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/ConfirmDialogExample'),
    },
    {
      path: '/demo/valet/ButtonLoaderExample',
      name: 'ButtonLoaderExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/ButtonLoaderExample'),
    },
    {
      path: '/demo/valet/ContextMenuExample',
      name: 'ContextMenuExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/ContextMenuExample'),
    },
    {
      path: '/demo/valet/DatePickerExample',
      name: 'DatePickerExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/DatePickerExample'),
    },
    {
      path: '/demo/valet/DatePickerOpenExample',
      name: 'DatePickerOpenExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/DatePickerOpenExample'),
    },
    {
      path: '/demo/valet/ListMenuExample',
      name: 'ListMenuExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/ListMenuExample'),
    },
    {
      path: '/demo/valet/ListExample',
      name: 'ListExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/ListExample'),
    },
    {
      path: '/demo/valet/LoadingSpinnerExample',
      name: 'LoadingSpinnerExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/LoadingSpinnerExample'),
    },
    {
      path: '/demo/valet/ModalExample',
      name: 'ModalExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/ModalExample'),
    },
    {
      path: '/demo/valet/OptionToggleExample',
      name: 'OptionToggleExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/OptionToggleExample'),
    },
    {
      path: '/demo/valet/SideMenuExample',
      name: 'SideMenuExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/SideMenuExample'),
    },
    {
      path: '/demo/valet/TabsExample',
      name: 'TabsExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/TabsExample'),
    },
    {
      path: '/demo/valet/ThreeLoadingDotsExample',
      name: 'ThreeLoadingDotsExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/ThreeLoadingDotsExample'),
    },
    {
      path: '/demo/valet/ToastNotificationExample',
      name: 'ToastNotificationExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/ToastNotificationExample'),
    },
    {
      path: '/demo/valet/ToggleButtonExample',
      name: 'ToggleButtonExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/ToggleButtonExample'),
    },
    {
      path: '/demo/valet/ToggleSwitchExample',
      name: 'ToggleSwitchExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/ToggleSwitchExample'),
    },
    {
      path: '/demo/valet/UserButtonExample',
      name: 'UserButtonExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/UserButtonExample'),
    },
    {
      path: '/demo/valet/UserInformationExample',
      name: 'UserInformationExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/UserInformationExample'),
    },
    {
      path: '/demo/valet/YearMonthPickerExample',
      name: 'YearMonthPickerExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/valet/YearMonthPickerExample'),
    },
    {
      path: '/demo/okta2/',
      name: 'Okta2Examples',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/okta2'),
    },
    {
      path: '/demo/okta2/BannerWelcomeExample',
      name: 'BannerWelcomeExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/okta2/BannerWelcomeExample'),
    },
    {
      path: '/demo/okta2/CardBalanceExample',
      name: 'CardBalanceExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/okta2/CardBalanceExample'),
    },
    {
      path: '/demo/okta2/HeaderAuthExample',
      name: 'HeaderAuthExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/okta2/HeaderAuthExample'),
    },
    {
      path: '/demo/okta2/InputPasswordExample',
      name: 'InputPasswordExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/okta2/InputPasswordExample'),
    },
    {
      path: '/demo/okta2/InputPhoneExample',
      name: 'InputPhoneExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/okta2/InputPhoneExample'),
    },
    {
      path: '/demo/okta2/InputSmsExample',
      name: 'InputSmsExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/okta2/InputSmsExample'),
    },
    {
      path: '/demo/okta2/TheFooterExample',
      name: 'TheFooterExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/okta2/TheFooterExample'),
    },
    {
      path: '/demo/okta2/TheNavigationExample',
      name: 'TheNavigationExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/okta2/TheNavigationExample'),
    },
    {
      path: '/demo/okta2/ValidityPasswordExample',
      name: 'ValidityPasswordExample',
      component: () => import(/* webpackChunkName: "Demo" */ '../components/ui/demo/okta2/ValidityPasswordExample'),
    },
  ],
};

if(process.env && process.env.NODE_ENV === 'development') {
  routes.splice(-1, 0, demoRoute);
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0, behavior: 'instant' }
  },
});

router.beforeEach(async (to, from, next) => {
  let activeUser = store.getters?.oktaActiveUser;
  if(!activeUser) {
    activeUser = window.localStorage.getItem('okta-active-user') || false;
    store.commit('updateOktaActiveUser', activeUser);
  }
  try {
    await _.setupOktaAuthenticated();

  } catch {}
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if(!store.getters?.oktaIsAuthenticated || !store.getters?.ciToken) {
      const query = !['/dashboard', '/signout'].includes(to.fullPath) ? { redirect: to.fullPath } : null;
      next({ path: '/login', query });
    } else {
      next();
    }
  } else if(
    store.getters?.oktaIsAuthenticated
    && ['/login', '/signup'].find((item) => (
      to.fullPath.includes(item)
      // To stop a redirection loop - the below path will resolve as true when looking for '/login' in the path string
      && !to.fullPath.includes('/login/callback'))
      && !to.fullPath.includes('/login/error')
      // They can access this page even if they're logged in
      && !to.fullPath.includes('/login/profile/email')
    )
  ) {
    next({ path: '/login/callback' });
  } else {
    next();
  }
});

export default router;
